module.exports = __webpack_public_path__ + "img/clock-icon.ef035d1a.svg";